const quizSettings = {
  maxLen: 500
};

export default quizSettings;




// WEBPACK FOOTER //
// ./src/constants/quiz-settings.js